package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.line.GeometryLineData
import com.macrofocus.eflux.network.logical.LogicalBranchId
import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.substation.GeometrySubstationData

open class GeometryNetworkCapability(
    val substations: Set<LogicalBusId>,
    val lines: Set<LogicalBranchId>,

    val substationData: (LogicalBusId) -> GeometrySubstationData,
    val lineData: (LogicalBranchId) -> GeometryLineData
) : NetworkCapability